import styled from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledUserTypeFilterWrapper = styled(Flexbox)`
    flex-shrink: 0;
`
